import moment from "moment";
import React, { useEffect, useState } from "react";
import SVGCircle from "./SvgCricle";

const CountDown = ({ timeTillDate, name, checkCallback }) => {
  const [state, setState] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const mapNumber = (number, in_min, in_max, out_min, out_max) => {
    return (
      ((number - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  };
  useEffect(() => {
    const x = setInterval(() => {
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance =  new Date(timeTillDate)?.getTime() - now;
    
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setState({
        days: days ,
        hours: hours ,
        minutes: minutes,
        seconds: seconds,
      });
      if (distance < 0) {
        clearInterval(x);
        checkCallback();
      }
    }, 1000);
  }, []);

  const daysRadius = mapNumber(state?.days, 30, 0, 0, 360);
  const hoursRadius = mapNumber(state?.hours, 24, 0, 0, 360);
  const minutesRadius = mapNumber(state?.minutes, 60, 0, 0, 360);
  const secondsRadius = mapNumber(state?.seconds, 60, 0, 0, 360);

  return (
    <div className="mainCountdown">
      <h4 className="mainh4">{name}</h4>
      <h4 className="subh4">Biểu mẫu sẽ hoạt động sau:</h4>
      <div className="countdown-wrapper">
        {state?.days > 0&& (
          <div className="countdown-item">
            <SVGCircle radius={daysRadius} />
            {state?.days}
            <span>ngày</span>
          </div>
        )}
        {state?.hours > 0 && (
          <div className="countdown-item">
            <SVGCircle radius={hoursRadius} />
            {state?.hours}
            <span>giờ</span>
          </div>
        )}
        {state?.minutes> 0 && (
          <div className="countdown-item">
            <SVGCircle radius={minutesRadius} />
            {state?.minutes}
            <span>phút</span>
          </div>
        )}
        {state?.seconds > 0&& (
          <div className="countdown-item">
            <SVGCircle radius={secondsRadius} />
            {state?.seconds}
            <span>giây</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CountDown;
